// ======================================================================
// File Name       : ServiceRecordUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import { DEFAULT_YEAR_MONTH } from '../constants/index';
import * as Path from '../constants/PathConstants';

export const now = moment();
export function getPath(route) {
  let path = { apiPath: '', drillServer: '' };
  switch (route) {
    case Path.SERVICE_RECORD_COMPANY_LIST:
      path = {
        apiPath: 'usage/GetEnterpriseUsageList',
        drillServer: false,
        isCompany: true,
        isServiceList: false,
      };
      break;
    case Path.SERVICE_RECORD_SERVICE_LIST:
      path = {
        apiPath: 'usage/GetServiceUsageList',
        drillServer: false,
        isCompany: false,
        isServiceList: false,
      };
      break;
    // Step 12.3.0 TAS-21359 START
    case Path.SERVICE_RECORD_SERVICES_LIST:
      path = {
        apiPath: 'usage/GetServiceUsageList',
        drillServer: false,
        isCompany: false,
        isServiceList: true,
      };
      break;
    // Step 12.3.0 TAS-21359 END
    default:
      break;
  }
  return path;
}

export function getDownloadFormMonths() {
  const targetMonths = [];
  let i = 1;
  for (i; i <= 12; i++) {
    const month = moment().subtract(i, 'month');
    const monthTemp = { name: month.format(DEFAULT_YEAR_MONTH), value: month.format(DEFAULT_YEAR_MONTH) };
    targetMonths.push(monthTemp);
  }
  return targetMonths;
}

export function getSystemUsageMonth() {
  const targetMonths = [];
  let i = 0;
  for (i; i <= 11; i++) {
    const month = moment().subtract(i, 'month');
    const monthTemp = { name: month.format(DEFAULT_YEAR_MONTH), value: month.format(DEFAULT_YEAR_MONTH) };
    targetMonths.push(monthTemp);
  }
  return targetMonths;
}
export function convertByte(bytes) {
  const sizes = ['Byte', 'KByte', 'MByte', 'GByte', 'TByte'];
  if (bytes == null || bytes == undefined ){
    return '';
  } 
  if (bytes == 0){
    return "0 Byte";
  }
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  if (i == 0) {
    return bytes + ' ' + sizes[i];
  }
  return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
};

export function convertToHour(seconds) {
  return seconds ? (seconds / 3600).toFixed(1) : '0';
}

// Step 12.3.0 TAS-21359 START
export function getServiceUsageListForServiceList(data) {
  const groupedServiceUsageList = data && data.reduce((acc, item) => {
    const key = item.serviceCd;

    const renameMap = {
      idTotalNum: 'maxNumId',
      videoStorageUsage: 'maxVideoStorage',
      multiLanguageDocumentPage: 'maxMultiLanguageDocumentPage'
    };

    const storageFields = ['documentS3Usage', 'clientContentsS3Usage', 'drillS3Usage', 'drillDbUsage', 'otherS3Usage'];
    const videoFlowFields = ['ownVideoFlow', 'distributionVideoFlow'];

    if (!acc[key]) {
      acc[key] = {
        serviceCd: key,
        ...Object.fromEntries(
          Object.entries(renameMap).map(([original, renamed]) => [renamed, item[original]])
        ),
        maxTotalStorage: storageFields.reduce((sum, f) => sum + (item[f] || 0), 0),
        maxTotalVideoFlow: videoFlowFields.reduce((sum, f) => sum + (item[f] || 0), 0),
      };
    } else {
      Object.entries(renameMap).forEach(([original, renamed]) => {
        acc[key][renamed] = Math.max(acc[key][renamed], item[original]);
      });

      const totalStorage = storageFields.reduce((sum, f) => sum + (item[f] || 0), 0);
      acc[key].maxTotalStorage = Math.max(acc[key].maxTotalStorage, totalStorage);

      const totalVideoFlow = videoFlowFields.reduce((sum, f) => sum + (item[f] || 0), 0);
      acc[key].maxTotalVideoFlow = Math.max(acc[key].maxTotalVideoFlow, totalVideoFlow);
    }

    return acc;
  }, {});

  return groupedServiceUsageList;
}
// Step 12.3.0 TAS-21359 END
